import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class EntityEventService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getRegistry() {
        try {
            const r = await withRetry(() => this.api.getAll(), { maxRetries: 2 });
            return { success: true, data: r.data || {} };
        } catch (e) {
            throw this._handle(e, 'Failed to load entity event registry');
        }
    }

    async getEventsForEntityType(entityType) {
        try {
            const r = await withRetry(() => this.api.getById(entityType), { maxRetries: 2 });
            return { success: true, data: r.data || [] };
        } catch (e) {
            throw this._handle(e, 'Failed to load entity events');
        }
    }

    _handle(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
